export default __webpack_public_path__ + "static/media/coverBackground.b4996d85.png";